export default __webpack_public_path__ + "static/media/hashim_khanzada_cv.57d74824.pdf";